import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      meta: { requiresGuest: true },
    },
    
    // {
    //   path: '/home',
    //   name: 'Home',
    //   component: () => import(/* webpackChunkName: "about" */ '@/views/Home.vue'),
    //   meta: { requiresAuth: true },
    // },
    {
      path: '/profile-update',
      name: 'ProfileUpdate',
      component: () => import(/* webpackChunkName: "profile-update" */ '@/views/ProfileUpdate.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/my-account',
      name: 'MyAccount',
      component: () => import(/* webpackChunkName: "my-account" */ '@/views/MyAccount.vue'),
      meta: { requiresAuth: true },
    },
     {
          path: "/expert-list",
          name: "ExpertChat",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ChatExpertList.vue"),
          meta: { requiresAuth: true },
        },

         {
          path: "/chat_window",
          name: "ChatWindow",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ChatPage.vue"),
          meta: { requiresAuth: true },
        },  

        {
          path: "/chat",
          name: "ChatPage",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/ChatPage.vue"),
          meta: { requiresAuth: true },
        },
          {
          path: "/pricing/:method?",
          name: "pricing",
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () =>
            import(/* webpackChunkName: "about" */ "./views/Pricing.vue"),
           meta: { requiresAuth: true },
          props(route) {
            return route.params || {};
          },
        },
  ],
});

// Global Auth Guard
router.beforeEach((to, from, next) => {
  const isLoggedIn = !!localStorage.getItem('profile');

  if (to.matched.some(record => record.meta.requiresAuth) && !isLoggedIn) {
    next({ path: '/' });
  } else if (to.matched.some(record => record.meta.requiresGuest) && isLoggedIn) {
    next({ path: '/expert-list' });
  } else {
    next();
  }
});

export default router;
